import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { PageDataService } from '../services/page-data.service';

@Directive({
    selector: '[appMySwipe]',
    outputs: ['mySwipeLeft', 'mySwipeRight']
})
export class MySwipeDirective implements OnInit, OnDestroy {

    @Output() mySwipeLeft = new EventEmitter<boolean>();
    @Output() mySwipeRight = new EventEmitter<boolean>();

    private touchstartX: number = 0;
    private touchendX: number = 0;

    // Store handler functions for proper removal
    private touchStartHandler = (e: TouchEvent) => this.handleTouchStart(e);
    private touchEndHandler = (e: TouchEvent) => this.handleTouchEnd(e);

    constructor(
        private elementRef: ElementRef,
        private pageData: PageDataService
    ) {}

    ngOnInit() {
        // Add passive event listeners to avoid blocking default behavior
        this.elementRef.nativeElement.addEventListener('touchstart', this.touchStartHandler, { passive: true });
        this.elementRef.nativeElement.addEventListener('touchend', this.touchEndHandler, { passive: true });
    }

    private handleTouchStart(e: TouchEvent) {
        this.touchstartX = e.changedTouches[0].screenX;
        this.pageData.increasSswipeCountDebug1();
        e.stopPropagation();
    }

    private handleTouchEnd(e: TouchEvent) {
        this.touchendX = e.changedTouches[0].screenX;
        this.checkDirection(e);
        this.pageData.increasSswipeCountDebug2();
        e.stopPropagation();
    }

    private checkDirection(e: TouchEvent) {
        const swipeThreshold = 50; // Minimum distance for a swipe (adjust as needed)
        if (this.touchendX < this.touchstartX - swipeThreshold) {
            // Detected a left swipe
            this.mySwipeLeft.emit(true);
            e.stopPropagation(); // Stop propagation only for swipes
        }
        if (this.touchendX > this.touchstartX + swipeThreshold) {
            // Detected a right swipe
            this.mySwipeRight.emit(true);
            e.stopPropagation(); // Stop propagation only for swipes
        }
    }

    ngOnDestroy() {
        // Properly remove event listeners
        this.elementRef.nativeElement.removeEventListener('touchstart', this.touchStartHandler);
        this.elementRef.nativeElement.removeEventListener('touchend', this.touchEndHandler);
    }
}
